import { useTranslation } from "react-i18next";
import { renderItem } from "./renderItem";

const fields = ["status", "payCodes", "hourTypes", "id"];

const CalculationRules = ({ data }) => {
    const { t } = useTranslation();
    const { mealPremium, clockException, shiftPremium } = data;

    const sections = [
        { label: "meal-premium", data: mealPremium },
        { label: "clock-exception", data: clockException },
        { label: "shift-premium", data: shiftPremium },
    ];

    return (
        <div className="tooltip-content-style">
            <h3 className="font-weight-bolder text-left mb-1">{t("calculation-rules")}</h3>
            {sections.map(({ label, data }) => (
                <div key={label}>
                    {fields.map(
                        (item, i) =>
                            data?.[item] && (
                                <div key={i}>
                                    <h4
                                        className="mb-2 text-left"
                                        style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}
                                    >
                                        {t(label)}
                                    </h4>
                                    {renderItem(data[item], item, t)}
                                </div>
                            )
                    )}
                </div>
            ))}
        </div>
    );
};

export default CalculationRules;
